import { Target } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PolicyField } from "./PolicyField";
import type { PolicyCardProps } from "./policy-card.types";

// Spec 079 — os VEREDITOS da aderência ao plano de uma produção em andamento.
// As faixas explicadas na tela são derivadas destes dois números (FR-036): mudá-los reescreve a
// legenda junto com o veredito, para que uma nunca contradiga o outro.
export function PlanAdherenceCard({ register, errors, disabled }: PolicyCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Target className="h-4 w-4 text-text-tertiary" aria-hidden />
          Vereditos de aderência ao plano
        </CardTitle>
      </CardHeader>
      <CardContent className="grid gap-4 sm:grid-cols-2">
        <PolicyField
          id="policy-adherence-low"
          label="Piso da faixa “no plano”"
          unit="%"
          hint="Abaixo dele a produção em andamento é marcada como atrasada."
          registration={register("planAdherenceLow", { valueAsNumber: true })}
          error={errors.planAdherenceLow}
          disabled={disabled}
          step="0.01"
        />
        <PolicyField
          id="policy-adherence-high"
          label="Teto da faixa “no plano”"
          unit="%"
          hint="Acima dele a produção é marcada como adiantada. Precisa ser maior que o piso."
          registration={register("planAdherenceHigh", { valueAsNumber: true })}
          error={errors.planAdherenceHigh}
          disabled={disabled}
          step="0.01"
        />
      </CardContent>
    </Card>
  );
}
